'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { consumePendingAnchor, scrollToAnchorWhenReady } from '@/lib/anchorScroll';

/**
 * Holt den beim Klick gemerkten Anker ab und springt ihn auf der neuen Seite an
 * (siehe AnchorButtonLink). Fängt zusätzlich Aufrufe mit Hash in der URL ab –
 * etwa aus externen Links – scrollt dorthin und entfernt den Hash wieder, damit
 * ein erneuter Klick auf denselben Anker wieder scrollt.
 */
export default function AnchorScroll() {
    const pathname = usePathname();

    useEffect(() => {
        const pending = consumePendingAnchor();
        if (pending) {
            scrollToAnchorWhenReady(pending);
            return;
        }

        const hash = window.location.hash.slice(1);
        if (!hash) return;

        history.replaceState(null, '', window.location.pathname + window.location.search);
        scrollToAnchorWhenReady(decodeURIComponent(hash));
    }, [pathname]);

    return null;
}
